module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('transition', {
    attrs: {
      "name": _vm.transition
    },
    on: {
      "after-leave": _vm.doDestroy
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopper),
      expression: "showPopper"
    }],
    ref: "popper",
    staticClass: "zk-popover",
    class: [_vm.popperClass],
    style: ({
      width: _vm.width + 'px'
    })
  }, [(_vm.title) ? _c('div', {
    staticClass: "zk-popover__title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.content))])], 2)]), _vm._v(" "), _vm._t("reference")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-962275d6"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/popover/src/popover.vue
// module id = 273
// module chunks = 0